export default class GetUserPreferences {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid) {
    try {
      const preferences = await this.userRepository.getUserPreferences(uid);
      return preferences;
    } catch (error) {
      console.error('Error getting user preferences:', error);
      return null;
    }
  }
} 